var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotificationWarning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#ffb300",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    fill: "#ffb300",
    d: "M10.964 29h18.072c1.848 0 3-2.004 2.076-3.6L22.076 9.788c-.924-1.596-3.228-1.596-4.152 0L8.888 25.4c-.924 1.596.228 3.6 2.076 3.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M20 20.6c-.66 0-1.2-.54-1.2-1.2V17c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v2.4c0 .66-.54 1.2-1.2 1.2zm1.2 4.8h-2.4V23h2.4v2.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationWarning);
export default __webpack_public_path__ + "static/media/notification-warning.4509dd1e4a922137edba60b9df51adf9.svg";
export { ForwardRef as ReactComponent };